import { useState } from 'react';

const faqs = [
  {
    question: 'SpaProBridge kariyer sitesi mi?',
    answer: 'Hayır. SpaProBridge, geleneksel bir kariyer sitesi veya açık ilan platformu değildir. Burada herkesin görebileceği ilanlar yayınlanmaz. Platform; terapistler ile spa işletmelerini gizlilik, güven ve kontrollü iletişim altyapısıyla özel olarak eşleştirir. Amaç "çok kişiye görünmek" değil, "doğru kişiye görünmek"tir.',
  },
  {
    question: 'Terapistler ücret öder mi?',
    answer: 'Hayır, terapistler için platforma kayıt ve kullanım tamamen ücretsizdir. Terapistler profil oluşturabilir, görünürlük modunu seçebilir ve kabul ettikleri işletmelerle iletişim kurabilir — herhangi bir ücret ödemeden.',
  },
  {
    question: 'Spa işletmeleri nasıl ödeme yapar?',
    answer: 'Spa işletmeleri kredi bazlı bir modelle çalışır. Kredi, yalnızca terapist bir iletişim talebini kabul ettiğinde kullanılır. Talep gönderirken kredi düşmez. Bu sayede işletmeler yalnızca gerçek bağlantılar için ödeme yapar.',
  },
  {
    question: 'Telefon bilgilerim görünür mü?',
    answer: 'Hayır. Telefon numarası, WhatsApp, Instagram ve açık adres gibi kişisel iletişim bilgileri çift taraflı onay olmadan hiçbir şekilde paylaşılmaz. Platform içindeki güvenli yazılı chat sistemi bu bilgilere ihtiyaç duymadan iletişimi sağlar.',
  },
  {
    question: 'Sessiz Kariyer modu nedir?',
    answer: 'Sessiz Kariyer modu; aktif iş aramasanız bile yeni fırsatlara açık olmanızı sağlayan özel bir görünürlük modudur. Bu modda profiliniz herkese açık değildir. İsim, fotoğraf ve iletişim bilgileriniz gizli kalır; yalnızca yüksek uyum skoru olan spa işletmelerine kontrollü şekilde gösterilirsiniz.',
  },
  {
    question: 'Chat üzerinden telefon paylaşılabilir mi?',
    answer: 'Hayır. Platform chat sistemi, telefon numarası, WhatsApp linki, Instagram kullanıcı adı gibi kişisel iletişim bilgilerinin paylaşılmasını filtreler. Bu bilgilerin paylaşımı yalnızca her iki tarafın da onaylamasıyla mümkündür. Etik dışı içerik ve ihlaller ağır moderasyona tabidir.',
  },
  {
    question: 'Platform terapist garantisi verir mi?',
    answer: 'SpaProBridge bir terapist ajansı değildir ve belirli bir terapisti işletmelere garanti etmez. Platform; nitelikli, doğrulanmış ve admin onaylı terapistleri güvenli bir şekilde işletmelerle buluşturan bir eşleşme altyapısı sunar. Nihai karar her zaman her iki tarafa aittir.',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="sss" className="w-full bg-off-white py-14 md:py-20 lg:py-24">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 bg-dark-teal-50 text-dark-teal-500 text-xs font-semibold rounded-full mb-4">
              Sıkça Sorulan Sorular
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-deep-navy-500 leading-tight mb-4">
              Sorularınızı yanıtlıyoruz
            </h2>
            <p className="text-sm md:text-base text-gray-500 max-w-xl mx-auto">
              SpaProBridge hakkında merak edilen en yaygın sorular ve yanıtları.
            </p>
          </div>

          <div className="space-y-3">
            {faqs.map((faq, i) => {
              const isOpen = openIndex === i;
              return (
                <div
                  key={i}
                  className={`bg-white rounded-xl border overflow-hidden transition-all duration-200 ${
                    isOpen ? 'border-dark-teal-200' : 'border-gray-100'
                  }`}
                >
                  <button
                    onClick={() => setOpenIndex(isOpen ? null : i)}
                    className="w-full flex items-center justify-between p-4 md:p-5 cursor-pointer text-left"
                  >
                    <span className="text-sm font-semibold text-deep-navy-500 pr-4">{faq.question}</span>
                    <span
                      className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 transition-colors ${
                        isOpen ? 'bg-dark-teal-50' : 'bg-off-white'
                      }`}
                    >
                      <i
                        className={`text-base transition-transform duration-200 ${
                          isOpen
                            ? 'ri-subtract-line text-dark-teal-500'
                            : 'ri-add-line text-gray-400'
                        }`}
                      />
                    </span>
                  </button>
                  {isOpen && (
                    <div className="px-4 md:px-5 pb-4 md:pb-5">
                      <p className="text-sm text-gray-500 leading-relaxed">{faq.answer}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}